import Link from 'next/link';
import { useMemo } from 'react';
import { useRouter } from 'next/router';
import styles from './styles.module.scss';
import { useToggle } from '@starsoft/common/hooks';
import { navigation } from '@/constants/navigation';
import useTranslation from 'next-translate/useTranslation';
import { IconButton, RichTooltip } from '@starsoft/common/components';

export default function LayoutHeaderMobileNavigation() {
  const [open, toggleOpen] = useToggle();
  const { t } = useTranslation('common');
  const { asPath } = useRouter();

  const Items = useMemo(
    () =>
      navigation.map(page => (
        <Link
          key={`navigation-header-${page.label}`}
          href={page?.path}
          className={`${styles.container__label} ${asPath.includes(page.path) ? styles['container__label--active'] : ''}`}
        >
          {t(page?.label)}
        </Link>
      )),
    [t, asPath],
  );

  return (
    <RichTooltip
      open={open}
      onClose={toggleOpen}
      content={<div className={styles.container}>{Items}</div>}
    >
      <IconButton onClick={toggleOpen}>
        <i className="fa-duotone  fa-bars" />
      </IconButton>
    </RichTooltip>
  );
}
